import { Expense, ExpenseService } from '../../expense';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, AuthenticationService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property/property.service';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-expense',
    templateUrl: './expense.component.html',
    styleUrls: ['./expense.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ExpenseComponent implements OnInit {
	expenseCategories: any;
	vendors: any;
	properties: any[]=[];
	priorities: any;
	isDeleting: boolean = false;
	constructor(
		private primengConfig: PrimeNGConfig,
		private expenseService: ExpenseService,
		private alertService: AlertService,
		private propertyService: PropertyService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private activatedRoute: ActivatedRoute,
		private authenticationService: AuthenticationService,
		@Optional() @Inject(MAT_DIALOG_DATA) data: any) {
		this.isDialogMode = data?.isDialogMode ?? false;
		this.formTitle = data?.title ?? 'Edit Expense';
		this.expense = data?.expense ?? null;
		this.statuses = expenseService.statuses;
		this.expenseCategories = expenseService.expenseCategories;
		this.vendors = expenseService.vendors;
		this.priorities = expenseService.priorities;
	}

	isDialogMode: boolean = false;
	@Input() expense: Expense;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	expenseId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'expenseId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [
			{ type: 'required', message: 'Required' }
		],
		'expenseDate': [],
		'isExpense': [],
		stmtBilledDate: [
			{ type: 'required', message: 'Required' }
		],
		topicId:[],
			expenseVendor:[],
			expenseVendorId:[],
			assignedToName:[
				{ type: 'required', message: 'Required' }
			],
			createdByUserName:[
				{ type: 'required', message: 'Required' }
			],
			workOrderCreateDate:[],
			completedByUserName:[],
			completedDate: [],
			requestedBy:[],
			scheduledDateTime:[],
			startDateTime:[],
			priority:[],
			expenseCategory: [
			{ type: 'required', message: 'Required' }
			],
			vendorReportUrl:[],
			vendorUpdateDateTime:[],
			shortTermRentalId:[
				{ type: 'required', message: 'Required' }
			],
			changeLog:[],
			showToStmt:[]

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();

		const expenseIdFromDialog = this.expense?.expenseId;
		const expenseIdParam = this.activatedRoute.snapshot.paramMap.get('expenseId');
		const idToLoad = expenseIdFromDialog ?? (expenseIdParam ? Number(expenseIdParam) : null);

		if (idToLoad && !isNaN(idToLoad)) {
			this.formLoading = true;
			this.expenseService.findById(idToLoad).pipe(first()).subscribe({
				next: (res) => {
					this.expense = res?.data?.expense;
					if (this.expense) {
						this.setExpense();
					}
				},
				error: () => {
					this.formLoading = false;
					this.alertService.error('Failed to load expense.');
				},
				complete: () => { this.formLoading = false; }
			});
		} else {
			this.setExpense();
		}
	}


	setExpense() {
		if (this.expense) {
			this.expenseId = this.expense.expenseId;
			this.form1.patchValue({
				...this.expense,
				stmtBilledDate: this.parseDate(this.expense?.stmtBilledDate),
				workOrderCreateDate: this.parseDate(this.expense?.workOrderCreateDate),
				completedDate: this.parseDate(this.expense?.completedDate),
				scheduledDateTime: this.parseDate(this.expense?.scheduledDateTime),
				startDateTime: this.parseDate(this.expense?.startDateTime),
				vendorUpdateDateTime: this.parseDate(this.expense?.vendorUpdateDateTime),
				expenseDate: this.parseDate(this.expense?.expenseDate),
			});
			this.formTitle = 'Edit Expense';
		} else {
			const currentUser = this.authenticationService?.currentUserValue;
			const loggedInUserFullName = currentUser
				? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || null
				: null;
			this.form1.patchValue({ createdByUserName: loggedInUserFullName });
			this.formTitle = 'Add Expense';
		}
	}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryIndividualPropertyList()
			.subscribe(
			  res => {
				// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
				this.properties = res.data.properties;
			  },
			  err => {
				console.log('Feature-Update FAIL: ' + JSON.stringify(err));
				this.alertService.error(err);
			  },
			  () => { });
		} catch (error) {
		  console.log('Form Invalid: ' + JSON.stringify(error));
		  this.alertService.error(error);
		}
	  }

	openVendorReportUrl(): void {
		const url = this.form1.get('vendorReportUrl')?.value?.trim();
		if (!url) return;
		const href = url.startsWith('http://') || url.startsWith('https://') ? url : 'https://' + url;
		window.open(href, '_blank', 'noopener,noreferrer');
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.expenseId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			const payload = this.buildPayload();
			payload?.expenseId ? delete payload.expenseId : '';

			this.expenseService.add(payload)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.expense = res.data.expense;
						this.setExpense();
						this.doAdd.emit(this.expense);
					},
					(err: any) => {
						console.log('expense-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('expense: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			this.formLoading = true;

			this.expenseService.update(this.buildPayload())
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.expense = res.data.expense;
						this.setExpense();
						this.doUpdate.emit(this.expense);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.isDeleting = true;
			this.expenseService.delete(this.expense.expenseId)
				.subscribe(
					(res: any) => {
						console.log('expense-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.isDeleting = false;
						this.doDelete.emit(this.expense);
					},
					(err: any) => {
						this.isDeleting = false;
						console.log('expense-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.isDeleting = false; });
		} catch (error) {
			this.isDeleting = false;
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			expenseId: [this.expenseId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [1, Validators.required],
			expenseDate: [],
			isExpense: [],
			stmtBilledDate:[''],
			topicId:[],
			expenseVendor:[1],
			expenseVendorId:[],
			assignedToName:[],
			createdByUserName:[null, Validators.required],
			workOrderCreateDate:[],
			completedByUserName:[],
			completedDate:[''],
			requestedBy:[],
			scheduledDateTime:[],
			startDateTime:[],
			priority:[],
			expenseCategory:[null, Validators.required],
			vendorReportUrl:[],
			vendorUpdateDateTime:[],
			shortTermRentalId:[null, Validators.required],
			changeLog:[],
			showToStmt:[]

		});
	}

		/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
	
	private parseDate(value: any): Date | null {
		if (!value) return null;

		if (value instanceof Date) {
			return value;
		}

		// Accept: yyyy-MM-dd or yyyy-MM-ddTHH:mm:ss
		const s = value.replace('Z', '');
		const [datePart, timePart] = s.split('T');

		const [y, m, d] = datePart.split('-').map(Number);

		let hh = 0, mm = 0, ss = 0;
		if (timePart) {
			const t = timePart.split(':');
			hh = Number(t[0] || 0);
			mm = Number(t[1] || 0);
			ss = Number((t[2] || '0').substring(0, 2));
		}

		// IMPORTANT:
		// This creates a local Date with EXACT same fields
		// No UTC, no offset math
		return new Date(y, m - 1, d, hh, mm, ss);
	}



	private formatDate(value: any): string | null {
		if (!value) return null;

		// Already backend string → return as-is
		if (typeof value === 'string') {
			return value.replace('Z', '');
		}

		const d = value as Date;

		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		const hh = String(d.getHours()).padStart(2, '0');
		const mm = String(d.getMinutes()).padStart(2, '0');
		const ss = String(d.getSeconds()).padStart(2, '0');

		return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
	}



	private buildPayload(): any {
		const v = { ...this.form1.value };

		v.expenseDate = this.formatDate(v.expenseDate);
		v.stmtBilledDate = this.formatDate(v.stmtBilledDate);
		v.workOrderCreateDate = this.formatDate(v.workOrderCreateDate);
		v.completedDate = this.formatDate(v.completedDate);
		v.scheduledDateTime = this.formatDate(v.scheduledDateTime);
		v.startDateTime = this.formatDate(v.startDateTime);
		v.vendorUpdateDateTime = this.formatDate(v.vendorUpdateDateTime);

		return v;
	}


}
